import { combineReducers } from "redux";
import { DelActuReducer, DetailsActuReducer, SetActusReducer, LikeActuReducer, ListActuReducer, ViewActuReducer } from "./actus";
import { DelUserReducer, DetUserReducer, ForgotPwdOneReducer, ForgotPwdTwoReducer, GetIpUserReducer, IsAdminReducer, LoginReducer, NewUserReducer } from "./user";
import { ListMessageAdminHomeReducer, ListMessageAdminReducer, ListMessageReducer, NbMessageNoReadAdminReducer, NbMessageNoReadReducer, NbUserNewsletterReducer, SaveCoordMessageReducer, SaveNewsReducer, SendMessageAdminReducer, SendMessageReducer, SendNewsReducer } from "./contact";
import { DelGallerieReducer, GetDetailGallerieReducer, GetGallerieReducer, LikeGallerieReducer, SaveGallerieReducer } from "./gallerie";
import { GetIdttReducer, SaveIdttReducer } from "./identite";
import { DeleteParcReducer, DetailsParcReducer, ListParcActReducer, ListParcReducer, SaveParcReducer, SetEnableParcReducer } from "./parc";
import { DeleteRideReducer, DetailsRideQueueReducer, DetailsRideReducer, ListRideActReducer, ListRidesParcReducer, ListRidesReducer, SaveRideReducer, SetEnableRideReducer } from "./rides";
import { GetWaitimeFiltersReducer, GetWaitimeHistoReducer, GetWaitimeReducer } from "./waitime";
import { DeleteProjectReducer, DetailProjectReducer, ListProjectReducer, SaveProjectReducer } from "./project";
import { DeleteFolderReducer, DetailFolderReducer, ListFolderReducer, SaveFolderReducer } from "./folder";
import { DeleteFileReducer, DetailFileReducer, SaveFileReducer } from "./file";

const rootReducer = combineReducers({
    // Actualités
    redSetActu: SetActusReducer,
    redDelActu: DelActuReducer,
    redDetActu: DetailsActuReducer,
    redListActu: ListActuReducer,
    redLikeActu: LikeActuReducer,
    redViewActu: ViewActuReducer,
    // Contact
    redSendCtct: SendMessageReducer,
    redSaveCoord: SaveCoordMessageReducer,
    redSendAdminCtct: SendMessageAdminReducer,
    redListCtct: ListMessageReducer,
    redListAdmCtct: ListMessageAdminReducer,
    redListAdmHome: ListMessageAdminHomeReducer,
    redNbNoRead: NbMessageNoReadReducer,
    redNbNoReadAdmin: NbMessageNoReadAdminReducer,
    redSaveNews: SaveNewsReducer,
    redSendNews: SendNewsReducer,
    redGetNbNews: NbUserNewsletterReducer,
    // Gallerie
    redGetGall: GetGallerieReducer,
    redDetGall: GetDetailGallerieReducer,
    redSaveGall: SaveGallerieReducer,
    redDelGall: DelGallerieReducer,
    redLikeGall: LikeGallerieReducer,
    // Identité
    redSaveIdtt: SaveIdttReducer,
    redGetIdtt: GetIdttReducer,
    // User
    redLogin: LoginReducer,
    redAdmin: IsAdminReducer,
    redFgtPwdOne: ForgotPwdOneReducer,
    redFgtPwdTwo: ForgotPwdTwoReducer,
    redNewUser: NewUserReducer,
    redDelUser: DelUserReducer,
    redProfil: DetUserReducer,
    redUserIp: GetIpUserReducer,
    // Parc
    redParcs: ListParcReducer,
    redParc: DetailsParcReducer,
    redSaveParc: SaveParcReducer,
    redDelParc: DeleteParcReducer,
    redParcsAct: ListParcActReducer,
    redParcEnable: SetEnableParcReducer,
    // Rides
    redRides: ListRidesReducer,
    redRidesParc: ListRidesParcReducer,
    redRide: DetailsRideReducer,
    redSaveRide: SaveRideReducer,
    redDelRide: DeleteRideReducer,
    redRideQueue: DetailsRideQueueReducer,
    redRidesAct: ListRideActReducer,
    redRideEnable: SetEnableRideReducer,
    // Waitime
    redGetWait: GetWaitimeReducer,
    redGetWaitHisto: GetWaitimeHistoReducer,
    redGetWaitFilt: GetWaitimeFiltersReducer,
    // ====== Code =======
    // Project
    redCdPrList: ListProjectReducer,
    redCdPrDetail: DetailProjectReducer,
    redCdPrSave: SaveProjectReducer,
    redCdPrDel: DeleteProjectReducer,
    // Dossier
    redCdFldList: ListFolderReducer,
    redCdFldDetail: DetailFolderReducer,
    redCdFldSave: SaveFolderReducer,
    redCdFldDel: DeleteFolderReducer,
    // Fichier
    redCdFlDet: DetailFileReducer,
    redCdFlSave: SaveFileReducer,
    redCdFlDel: DeleteFileReducer
})

export default rootReducer;